import React from 'react';
import { Table, Header, Checkbox } from 'semantic-ui-react';
import _ from 'lodash';

const EmailSettingsRow = ({ name, email, id, sendDailyNotifications, sendWeeklyNotifications, onPermissionChange }) =>
  <Table.Row>
    <Table.Cell>
      <Header as="h4">
        <Header.Content>
          {name}
          <Header.Subheader>{email}</Header.Subheader>
        </Header.Content>
      </Header>
    </Table.Cell>
    <Table.Cell textAlign="center">
      <Checkbox
        value={sendDailyNotifications}
        defaultChecked={sendDailyNotifications}
        onClick={() => onPermissionChange({ id, key: 'sendDailyNotifications', value: !sendDailyNotifications })}
      />
    </Table.Cell>
    <Table.Cell textAlign="center">
      <Checkbox
        value={sendWeeklyNotifications}
        defaultChecked={sendWeeklyNotifications}
        onClick={() => onPermissionChange({ id, key: 'sendWeeklyNotifications', value: !sendWeeklyNotifications })}
      />
    </Table.Cell>
  </Table.Row>;

const EmailSettingsComponent = ({ teamMembers, campaignId, onPermissionChange, showManageLink }) =>
  <Table basic="very">
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell singleLine>Team Member</Table.HeaderCell>
        <Table.HeaderCell collapsing>Daily Summary</Table.HeaderCell>
        <Table.HeaderCell collapsing>Weeky Summary</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {_.map(teamMembers, member => <EmailSettingsRow {...member} onPermissionChange={onPermissionChange} />)}
    </Table.Body>
    <Table.Footer fullWidth>
      <Table.Row >
        <Table.HeaderCell colSpan={3} textAlign="center">
          {
            showManageLink &&
            <a href={`/campaign/${campaignId}/invite`}>Manage team members</a>
          }
        </Table.HeaderCell>
      </Table.Row>
    </Table.Footer>
  </Table>;

export default EmailSettingsComponent;



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-email-settings/email-settings-component.js
 **/